// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper__8SKAB2UpkuhBk","box":"box__anIXxXMlaSwZH","info":"info__V7lXpDL1xF2zG"};